var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAvrSessionDuration = function SvgAvrSessionDuration(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.125C11.4853 10.125 13.5 8.11028 13.5 5.625C13.5 3.13972 11.4853 1.125 9 1.125C6.51472 1.125 4.5 3.13972 4.5 5.625C4.5 8.11028 6.51472 10.125 9 10.125Z",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8325 16.3321C14.9686 14.8271 13.6319 13.6496 12.03 12.9824C10.4281 12.3152 8.65075 12.1956 6.97395 12.6423C5.29715 13.089 3.8148 14.0769 2.75714 15.4526C1.69948 16.8283 1.12573 18.5148 1.125 20.2501V23.6251H4.5L5.625 34.8751H12.375L12.861 30.0256",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 34.875C30.8456 34.875 34.875 30.8456 34.875 25.875C34.875 20.9044 30.8456 16.875 25.875 16.875C20.9044 16.875 16.875 20.9044 16.875 25.875C16.875 30.8456 20.9044 34.875 25.875 34.875Z",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.853 25.8749H25.875V21.8969",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 9C26.9246 9 28.6875 7.23712 28.6875 5.0625C28.6875 2.88788 26.9246 1.125 24.75 1.125C22.5754 1.125 20.8125 2.88788 20.8125 5.0625C20.8125 7.23712 22.5754 9 24.75 9Z",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6 13.4999C30.063 12.5703 29.312 11.7823 28.4093 11.2011C27.5067 10.62 26.4785 10.2625 25.41 10.1584C24.3415 10.0542 23.2636 10.2064 22.2658 10.6024C21.2679 10.9983 20.3789 11.6265 19.6725 12.4349",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAvrSessionDuration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avr-session-duration.28e347aa.svg";
export { ForwardRef as ReactComponent };